/** 与 appAudioLifecycle 中派发的事件名保持一致（供 BGM 等仅订阅事件名，避免循环依赖） */
export const WK_APP_BACKGROUND = 'wk-app-background';
export const WK_APP_FOREGROUND = 'wk-app-foreground';
